var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.90476C14.4667 1.90476 18.0952 5.53333 18.0952 10C18.0952 14.4667 14.4667 18.0952 10 18.0952C5.53333 18.0952 1.90476 14.4667 1.90476 10C1.90476 5.53333 5.53333 1.90476 10 1.90476ZM10 0C4.47619 0 0 4.47619 0 10C0 15.5238 4.47619 20 10 20C15.5238 20 20 15.5238 20 10C20 4.47619 15.5238 0 10 0Z",
    fill: "fillColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.74285 14.819L3.68571 10.7619C3.38095 10.4571 3.59999 9.95238 4.01904 9.95238H5.3619C5.48571 9.95238 5.60952 10 5.69523 10.0952L7.7238 12.1238C7.91428 12.3143 8.20952 12.3143 8.39999 12.1238L14.1238 6.4C14.2095 6.31428 14.3333 6.25714 14.4571 6.25714H15.8C16.2286 6.25714 16.4381 6.77143 16.1333 7.06666L8.40952 14.819C8.21904 15.0095 7.9238 15.0095 7.73333 14.819H7.74285Z",
    fill: "fillColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.664ef3f8f0beeec67e99a5d5a113b162.svg";
export { ForwardRef as ReactComponent };